import React from 'react';
import clsx from 'clsx';
import { Element, Link, Button } from '@americanexpress/aqx-components';
import { Sanitizer } from 'acq-components/lib/base-components/Sanitizer/Sanitizer';
import isProduction from 'src/universal/utils/isProduction';
import textRemoveTags from 'service_modules/utils/text-remove-tags';
import SupplementaryToolTip from 'src/universal/components/SuppModal/components';
import { sendDTMClickEvent } from 'service_modules/models/dtm-tagging';
import styles from './__styles__/tabControl.scss?modules';

const CtaRow = ({
  ctaLink,
  toolTipLink,
  onTooltipClick,
  offerTermsLink,
  rateAndFeesLink,
  shortName,
  cardData
}) => {
  const noTNC = !offerTermsLink && !rateAndFeesLink;
  let otlAriaLabel;
  let rflAriaLabel;
  let cardName = '';
  if (shortName && !noTNC) {
    cardName =
      (
        (cardData || []).find(obj => {
          return obj.shortName === shortName;
        }) || {}
      ).cardHeadline || '';
    otlAriaLabel = `${textRemoveTags(offerTermsLink.title)} for ${textRemoveTags(
      cardName
    )}`;
    rflAriaLabel = `${textRemoveTags(rateAndFeesLink.title)} for ${textRemoveTags(
      cardName
    )}`;
  }

  return (
    <Element
      className={clsx(
        styles.ctaRow,
        {
          [styles.hasToolTip]: !!toolTipLink
        },
        { [styles.noTNC]: noTNC }
      )}
    >
      {ctaLink && (
        <Button
          className={styles.cta}
          onClick={() => {
            if (!isProduction()) {
              console.log(`url: ${ctaLink.url}`);
            }
            window.location.href = ctaLink.url;
            sendDTMClickEvent(ctaLink.dtm || {});
          }}
          title={ctaLink.hoverText || ''}
        >
          {ctaLink.title}
        </Button>
      )}
      {toolTipLink && (
        <Element
          className={styles.ctaToolTip}
          Component="button"
          onClick={() => onTooltipClick()}
        >
          <SupplementaryToolTip dtmElement="tabbedHero" iconSize="md" />
        </Element>
      )}
      {!noTNC && (
        <Element className={styles.tncHolder}>
          {offerTermsLink && (
            <Link
              href={offerTermsLink.url}
              aria-label={otlAriaLabel}
              title={textRemoveTags(offerTermsLink.title)}
              target="_blank"
              onClick={() => {
                if (offerTermsLink.dtm) {
                  sendDTMClickEvent(offerTermsLink.dtm);
                }
              }}
            >
              <Sanitizer safelySetInnerHTML={offerTermsLink.title} />
            </Link>
          )}
          {rateAndFeesLink && (
            <Link
              href={rateAndFeesLink.url}
              title={textRemoveTags(rateAndFeesLink.title)}
              aria-label={rflAriaLabel}
              target="_blank"
              onClick={() => {
                if (rateAndFeesLink.dtm) {
                  sendDTMClickEvent(rateAndFeesLink.dtm);
                }
              }}
            >
              <Sanitizer safelySetInnerHTML={rateAndFeesLink.title} />
            </Link>
          )}
        </Element>
      )}
    </Element>
  );
};

export default React.memo(CtaRow);
